'use client'

import PropTypes from 'prop-types'
import MUITypography from '@mui/material/Typography'
import MUIStack from '@mui/material/Stack'

const EmptyComponent = () => null

export const WizardIconTitle = ({ title, text, icon, sx, variant = 'h4', isOptional = false, onClick }) => {
  const IconComponent = icon || EmptyComponent

  return (
    <MUIStack
      direction="column"
      gap={0}
      sx={{ width: '100%', cursor: onClick ? 'pointer' : 'auto', ...sx }}
      onClick={onClick}
    >
      <MUIStack direction="row" gap={4} alignItems="center" data-testid="WizardIconTitle">
        <IconComponent
          sx={{
            width: '40px',
            height: '40px',
            fontSize: '40px',
            cursor: onClick ? 'pointer' : 'auto',
            color2: '#3D517B'
          }}
        />
        <MUITypography variant={variant} sx={{ mb: 0, cursor: onClick ? 'pointer' : 'auto' }}>
          {title}
          {isOptional ? <span style={{ opacity: 0.75, fontSize: '0.875rem' }}> (optional)</span> : ''}
        </MUITypography>
      </MUIStack>
      {text ? (
        <MUITypography variant="body1" sx={{ mt: 5, mb: 2, cursor: onClick ? 'pointer' : 'auto' }}>
          {text}
        </MUITypography>
      ) : null}
    </MUIStack>
  )
}

WizardIconTitle.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.func,
  sx: PropTypes.object,
  variant: PropTypes.string,
  isOptional: PropTypes.bool,
  onClick: PropTypes.func
}
